const lessonData = {

  2: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/Cadaver-lab-main-photo-1-scaled.png', alt: 'Students gathered in a medical lab, observing a procedure.', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "4", current_scene: "2", previous_scene: "1",text: "Continue" },
    ],
    scene_number: "2",
    sidebar: true,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [`<p>Learn more about the <a href="https://bodydonation.med.arizona.edu/faqs" rel="_blank" ref="noopener noreferrer">Willed Body Program</a>.</p>`],
    text: [
      `<p>Every year over 100 medical students at the University of Arizona are required to engage with a dead body during their curriculum in the Gross Anatomy Lab. Working in teams of six, they spend from September to May learning gross anatomical structures, dissection techniques and humanistic values (i.e. compassion, respect, and empathy) through careful dissection of human bodies.</p><p>The bodies are the gifts of Arizona residents, who bequeath their bodies to the Willed Body Program at the university. At the end of the year, the donor bodies are cremated individually in accordance with Arizona state law.</p>
`
    ],
    title: null,
    videos: [],
    audio: [],
  },
  
  4: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/Rural-Rotation-1-768x588.jpg', alt: 'Native medical students talking in a clinical setting', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "8", current_scene: "4", previous_scene: "2",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Working with dead bodies is a common, and often challenging, part of medical education. For many students, working with a donor body is their closest encounter with death thus far, which is difficult for many students and may disenfranchise some students because of their religious or spiritual beliefs.</p><p>For example, some Arizona tribal nations have a strong taboo against touching a dead body.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  
  8: {
    checkpoint: false,
    last: false,
    checkpoints: [{
      alt: null,
      answer: false,
      content_type: 5,
      data:
        ``,
      order: 0,
      question_type: 2,
      scene_number: "8",
      sidebar: false,
    }],
    images: [],
    layoutNumber: 9,
    navigation: [
      { available_scene: "9", current_scene: "8", previous_scene: "4",text: "Continue" },
    ],
    scene_number: "8",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [],
    title: null,
    videos: [],
    audio: [],
  },
  9: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/com-t_treeblessing_khp_4187-gallery.jpg.webp', alt: 'Medical students participating in the tree planting ceremony.', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "9.1", current_scene: "9", previous_scene: "8",text: "Continue" },
    ],
    scene_number: "9",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Earlier that year, the Medical Humanities Program, which seeks to instill humanitarian
beliefs into the curriculum of upcoming physicians, had just started a tree planting ceremony to honor people who died and donated their bodies to science. Each year medical students – all of whom take anatomy classes – would plant a tree in a memorial garden.</p><p>Dr. Gonzales joined forces with the Medical Humanities Program and together they created the Tree Blessing Ceremony, which combines a traditional Native American blessing ceremony and a tree planting to honor those who have passed away and donated their bodies to science. He was given permission by his Yaqui elders to perform blessings for medical students – something he tells the participants, because it is important for the audience to know.</p>`,
    ],
    title: `A memorial garden`,
    videos: [],
    audio: [],
  },
  9.1: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/com-t_treeblessing_khp_4026-hero.jpg.webp', alt: 'Carlos Gonzales, MD, FAAFP, blesses second-year medical student, Angela Monetathchi of the Comanche Tribe, with the smoke from sacred herbs and an eagle feather wand during the annual College of Medicine – Tucson Tree Blessing Ceremony.', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "9.2", current_scene: "9.1", previous_scene: "9",text: "Continue" },
    ],
    scene_number: "9.1",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Your request for a blessing ceremony ended up transforming the way all students go through the Gross Anatomy Lab requirement.</p><p>The following year, a group of second-year medical students in white coats – symbolic of their membership in the medical profession – gathered in the memorial garden on the Tucson campus. Dr. Gonzales blessed the students with the smoke of sacred herbs (smudging) and invoked the Seven Sacred Directions.</p><p>Dr. Gonzales said, “I started performing the ceremony for the whole class using a prayer to the Seven Sacred Directions. This blessing involves recognizing the four cardinal points, and above us (father sky), below us (mother Earth) and the center (the creator). Each direction has certain energies associated with it. I therefore ask those energies to come into the circle and bless the students with those energies.”</p>`,
    ],
    title: `The next year`,
    videos: [],
    audio: [],
  },
  9.2: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
   
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "10", current_scene: "9.2", previous_scene: "9.1",text: "Continue" },
    ],
    scene_number: "9.2",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>The ceremony explores the Seven Sacred Directions, each put into the context of body donation.</p><ul><li>The East door regards vision, guidance, and direction, which speaks to the vision of the donor in wanting to be a teacher for the next generation of medicine.</li><li>The South explores the energy of the family, which is rooted in donation, as family members are part of the process of honoring the donors through memorial.</li><li>The Western door is where the deceased pass through, highly intertwined with the death of the donors.</li><li>The North handles strength and courage, which describes the qualities the donor exemplifies for choosing to donate.</li><li>Father Sky looks at respect and responsibility, which is of utmost importance in handling the donor.</li><li>Mother Earth explores nurturing and caring, which is inherent to the responsibilities of physicians.</li><li>Lastly the Center is the Creator, in which it is believed that everyone is created with a gift they find and share with others throughout their lifetime (the gift is the body and the knowledge that can be gained from it).</li></ul><p>“I also perform a smudging ceremony, where I bless each individual student with the smoke of the sacred cleansing and blessing herbs, which I burn in the abalone shell. The herbs are white sage, soft sage, sweetgrass, creosote leaves, copal, cedar and wild tobacco,” explained Dr. Gonzales. The ashes are placed in the ground when the memorial tree is planted.</p><p><p><strong>By speaking up about your concerns and seeking support from an expert advocate, you helped to create a lasting impact on this curriculum for future students.<strong></p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  10: {
    checkpoint: false,
    last: true,
    checkpoints: [],
    images: [],
    layoutNumber: 6,
    navigation: [{available_scene: "10", current_scene: "10", previous_scene: "7",text: "End Lesson" }],
    scene_number: "10",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>You’ve completed this case study lesson. You made important decisions about how to advocate for spiritual and religious needs.</p><p>You learned how students may be impacted by demands of medical education and how to think broadly about spiritual and cultural backgrounds when working with all sorts of people.</p>`
    ],
    title: "Lesson complete",
    videos: [],
    audio: [],
  },
};

export default lessonData;